<template>
  <header :class="{ pad: !isUserLoggedIn, indent: getSidebarStatus }">
    <div class="hamburger-logo">
      <Hamburger
        class="hamburger-button"
        @click.native="toggleSidebar"
      ></Hamburger>
      <a href="/" class="logo-link">
        <img
          class="logo"
          :src="require('@/assets/img/logo.png')"
          alt="painguide logo"
        />
      </a>
    </div>

    <router-link to="/" class="slogan">
      Symptom
      <span>&</span> Activity Monitoring
    </router-link>

    <a class="logout" href="#" @click.prevent="logout" v-if="isUserLoggedIn">
      <img
        class="logout-icon"
        :src="require('@/assets/img/logout.svg')"
        role="presentation"
      />
      <span class="logout-text">Log out</span>
    </a>
  </header>
</template>

<script>
import { mapMutations, mapGetters } from "vuex";
import firebase from "firebase/app";
import "firebase/auth";
import Hamburger from "@/components/Hamburger.vue";

export default {
  name: "Header",
  components: { Hamburger },
  methods: {
    ...mapMutations(["modifyLoggedIn", "showSidebar"]),

    logout() {
      this.modifyLoggedIn(false);
      firebase.auth().signOut();
    },

    toggleSidebar() {
      this.showSidebar();
    },
  },
  computed: {
    ...mapGetters(["getSidebarStatus"]),

    isUserLoggedIn() {
      return this.$store.getters.getLoggedInStatus;
    },
  },
};
</script>

<style scoped>
header {
  align-items: center;
  background-color: var(--michigan-blue);
  display: flex;
  justify-content: space-between;
  position: sticky;
  top: 0;
  z-index: 2;
}

.hamburger-logo {
  align-items: center;
  display: flex;
}

.slogan {
  color: var(--eggshell);
  font-family: BebasNeue;
  font-size: 35px;
  font-weight: 300;
  margin: 0;
  position: absolute;
  width: 960px;
  left: 50%;
  margin-left: -355px;
  padding-left: 1rem;
  text-decoration: none;
}

.slogan span {
  color: var(--michigan-maize);
}

.pad {
  padding-bottom: 1.125rem;
  padding-right: 2rem;
  padding-top: 1.125rem;
}

.logo {
  padding-left: 2rem;
}

.logout {
  appearance: none;
  background-color: var(--michigan-maize);
  border: 0;
  cursor: pointer;
  display: flex;
  flex: 0 0 90px;
  flex-direction: column;
  color: var(--dark);
  font-size: 0.875rem;
  font-weight: 600;
  margin-left: 1rem;
  padding: 1rem 0.5rem;
  text-align: center;
  text-decoration: none;
  text-transform: uppercase;
}

.logout-icon {
  margin: 0 auto 0.5rem;
  max-width: 21px;
}

.hamburger-button {
  display: none;
}

.block {
  display: block;
}

@media all and (max-width: 1280px) {
  .slogan {
    margin: 0;
    position: static;
    width: auto;
  }
}

@media all and (max-width: 800px) {
  header {
    transition: transform 0.25s ease-out;
  }
  header.indent {
    transform: translateX(255px);
    transition: transform 0.25s ease-in;
  }
  .slogan {
    display: none;
  }
  .hamburger-button {
    display: block;
  }
  .logo {
    padding-left: 0;
  }
}
</style>
